import template from './sw-cms-preview-acris-faq.html.twig';
import './sw-cms-preview-acris-faq.scss';

const { Component } = Shopware;

Component.register('sw-cms-preview-acris-faq', {
    template
});
